import { render, staticRenderFns } from "./StrokeButton.vue?vue&type=template&id=25bf3f7b"
import script from "./StrokeButton.vue?vue&type=script&lang=js"
export * from "./StrokeButton.vue?vue&type=script&lang=js"
import style0 from "./StrokeButton.vue?vue&type=style&index=0&id=25bf3f7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports